// Default map center for the admin dashboard. Rapidry's live serviceable area is
// a ~6 km radius around Sector 49 / Eros City Square, Gurugram - so maps should
// open there, not the previous Bengaluru placeholder.
export const GURUGRAM_CENTER = { lat: 28.413, lng: 77.055 } as const

// Zoom level that comfortably frames the ~6 km serviceable circle.
export const GURUGRAM_DEFAULT_ZOOM = 12
